// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Create new ' + \$ctrl.module"></sub-header>
  <div class="form-section form-section--header labelled-field" ng-if="\$ctrl.corporateCustomerEnabled && \$ctrl.module === 'customer'">
    <label>Customer type</label>
    <select ng-model="\$ctrl.customerTypeSettings"
            ng-change="\$ctrl.onCustomerTypeSettingsChange()"
            ng-options="entry.settings as entry.description for entry in \$ctrl.customerTypes"></select>
  </div>

  <customer-profile-body profile="\$ctrl.profile"
                         edit-mode="true"
                         module="\$ctrl.module"></customer-profile-body>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/new/new-customer-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;